var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 913 426",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #475942;\n      }\n\n      .cls-2 {\n        fill: #e2e2e2;\n      }\n\n      .cls-3 {\n        stroke: #475942;\n        stroke-linejoin: round;\n      }\n\n      .cls-3, .cls-4, .cls-5, .cls-6 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-width: 3px;\n      }\n\n      .cls-4, .cls-5, .cls-6 {\n        stroke: #2e3a2b;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-7 {\n        fill: #131f24;\n      }\n\n      .cls-8 {\n        fill: #d33939;\n      }\n\n      .cls-5 {\n        stroke-dasharray: 11.65 11.65;\n      }\n\n      .cls-9 {\n        fill: #67915e;\n      }\n\n      .cls-10 {\n        display: none;\n      }\n\n      .cls-6 {\n        stroke-dasharray: 10.91 10.91;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: -23,
    y: -20,
    width: 953,
    height: 459
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M54.73,414h842.8c4.13,0,7.48-3.35,7.48-7.48V109.56c0-5.16-5.1-8.77-9.96-7.05L52.24,399.47c-7.93,2.79-5.93,14.53,2.49,14.53Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 494.39,
    y: 148.13,
    width: 114,
    height: 69,
    rx: 11.83,
    ry: 11.83,
    transform: "translate(-29.35 193.52) rotate(-19.4)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 546.56,
    y: 152.89,
    width: 170,
    height: 3,
    transform: "translate(-15.42 218.55) rotate(-19.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M714.78,123.58l-7.89-1.48c-.89-.17-1.63.7-1.33,1.55l2.67,7.57c.3.86,1.42,1.07,2.01.38l5.23-6.1c.59-.69.21-1.76-.68-1.93Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 386.02,
    y: 209.46,
    width: 170,
    height: 3,
    transform: "translate(985.36 253.48) rotate(160.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M387.8,241.76l7.89,1.48c.89.17,1.63-.7,1.33-1.55l-2.67-7.57c-.3-.86-1.42-1.07-2.01-.38l-5.23,6.1c-.59.69-.21,1.76.68,1.93Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 494.57,
    y: 261.45,
    width: 170,
    height: 3,
    transform: "translate(635.08 -371.06) rotate(70.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M610.38,346.17l1.48-7.89c.17-.89-.7-1.63-1.55-1.33l-7.57,2.67c-.86.3-1.07,1.42-.38,2.01l6.1,5.23c.69.59,1.76.21,1.93-.68Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 438.01,
    y: 100.9,
    width: 170,
    height: 3,
    transform: "translate(600.14 629.73) rotate(-109.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M492.2,19.18l-1.48,7.89c-.17.89.7,1.63,1.55,1.33l7.57-2.67c.86-.3,1.07-1.42.38-2.01l-6.1-5.23c-.69-.59-1.76-.21-1.93.68Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 551.4,
    y: 181.16,
    width: 170,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M725.13,181.24l-6.95-4.01c-.79-.45-1.77.11-1.77,1.02v8.03c0,.91.99,1.48,1.77,1.02l6.95-4.01c.79-.45.79-1.59,0-2.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 381.18,
    y: 181.19,
    width: 170,
    height: 3,
    transform: "translate(932.36 365.37) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M377.45,184.1l6.95,4.01c.79.45,1.77-.11,1.77-1.02v-8.03c0-.91-.99-1.48-1.77-1.02l-6.95,4.01c-.79.45-.79,1.59,0,2.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 466.3,
    y: 266.28,
    width: 170,
    height: 3,
    transform: "translate(819.09 -283.52) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M552.72,356.51l4.01-6.95c.45-.79-.11-1.77-1.02-1.77h-8.03c-.91,0-1.48.99-1.02,1.77l4.01,6.95c.45.79,1.59.79,2.05,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 466.28,
    y: 96.07,
    width: 170,
    height: 3,
    transform: "translate(453.71 648.84) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M549.86,8.84l-4.01,6.95c-.45.79.11,1.77,1.02,1.77h8.03c.91,0,1.48-.99,1.02-1.77l-4.01-6.95c-.45-.79-1.59-.79-2.05,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 11,
    y1: 414,
    x2: 11,
    y2: 408
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 11,
    y1: 397.09,
    x2: 11,
    y2: 293.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 11,
    y1: 288,
    x2: 11,
    y2: 282
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 143,
    y1: 413.5,
    x2: 137,
    y2: 413.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 126.09,
    y1: 413.5,
    x2: 22.45,
    y2: 413.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 17,
    y1: 413.5,
    x2: 11,
    y2: 413.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 143,
    y1: 367,
    x2: 137.35,
    y2: 369.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 126.38,
    y1: 372.92,
    x2: 22.14,
    y2: 410.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 16.65,
    y1: 411.99,
    x2: 11,
    y2: 414
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "878.28 51.13 893.75 95.05 893.91 94.99 850 110.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M875.27,45.66l-1.48,7.89c-.17.89.7,1.63,1.55,1.33l7.57-2.67c.86-.3,1.07-1.42.38-2.01l-6.1-5.23c-.69-.59-1.76-.21-1.93.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M845.4,112.96l7.89,1.48c.89.17,1.63-.7,1.33-1.55l-2.67-7.57c-.3-.86-1.42-1.07-2.01-.38l-5.23,6.1c-.59.69-.21,1.76.68,1.93Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 551.22,
    cy: 182.15,
    r: 6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/Box.2b9a988f5aa23dc44758a33075102a14.svg";
export { ForwardRef as ReactComponent };